import Vue from 'vue'
import Router from 'vue-router'
import UepPlayer from '@/components/UepPlayer'
import UepMontagePlayer from '@/components/UepMontagePlayer'
import UepEditorPlayer from '@/components/UepEditorPlayer'
import UepPlayerLive from '@/components/UepPlayerLive'
import UepSousTitragePlayer from '@/components/UepSousTitragePlayer'
Vue.use(Router);

export default new Router({
  routes: [
    {
      name: 'live',
      path: '/live/:id',
      component: UepPlayerLive
    },
    {
      name: 'montage',
      path: '/montage/:id',
      component: UepMontagePlayer
    },
    {
      name: 'sous-titrage',
      path: '/sous-titrage/:id',
      component: UepSousTitragePlayer
    },
    {
      name: 'editor',
      path: '/editor/:id',
      component: UepEditorPlayer
    },
    {
      name: 'video',
      path: '/:id',
      component: UepPlayer
    }

  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./demo/router/index.js